// KUMA: break product titles before ［ ］
(function () {
  function applyBreak(root) {
    const targets = root.querySelectorAll(
      '.card__heading a, .card__heading, .product__title, .product__title h1'
    );

    targets.forEach((el) => {
      if (el.dataset.kumaBreakApplied === '1') return;

      const text = el.textContent || '';
      const idx = text.indexOf('［');
      if (idx === -1) {
        el.dataset.kumaBreakApplied = '1';
        return;
      }

      const before = text.slice(0, idx).trimEnd();
      const after = text.slice(idx).trimStart();

      el.innerHTML =
        `${before}<br><span class="kuma-title-sub">${after}</span>`;

      el.dataset.kumaBreakApplied = '1';
    });
  }

  function run() {
    applyBreak(document);
    document.addEventListener('shopify:section:load', (e) => applyBreak(e.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
